<template>
  <v-dialog :value="value" @click:outside="$emit('close-language-dialog')" width="600" persistent>
    <v-card>
      <v-card-title>Thêm ngoại ngữ</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-select outlined hide-details label="Ngoại ngữ" v-model="form.languageCode" :items="languages" item-text="vnName" item-value="code"></v-select>
          </v-col>
          <v-col cols="12">
            <v-select outlined hide-details label="Trình độ" v-model="form.languageLevelCode" :items="levels" item-text="vnName" item-value="code"></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" type="button" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import http from '../../../components/services/http-common';

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    
    employeeCode: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      languages: [],
      levels: [],
      form: {
        employeeCode: null,
        languageLevelCode: null,
        languageCode: null
      },
      
      defaultForm: {
        employeeCode: null,
        languageLevelCode: null,
        languageCode: null
      }
    }
  },
  methods: {
    fetchLanguage() {
      return http.get("languages?noLocale=true").then(r => {
        this.languages = r.data.data
      })
    },

    fetchLevel() {
      return http.get("languages/levels").then(r => {
        this.levels = r.data.data
      })
    },

    save() {
      this.form.employeeCode = this.employeeCode
      return http.post("languages/employee", this.form).then(() => {
        this.form = {...this.defaultForm}
        this.$emit('close-language-dialog')
      })
    }

  },
  mounted() {
    this.fetchLanguage()
    this.fetchLevel()
  }
}
</script>
